import React from 'react';
import ReportService from '../../Services/ReportService';
import ErrorMessage from '../ErrorMessage';
import BravoLoader from '../BravoLoader';
import { saveAs } from 'file-saver';
import ReportFrameOperationBar from './ReportFrameOperationBar';
import ReportFrameParameterBar from './ReportFrameParameterBar';

export default class ReportFrame extends React.Component {
  static defaultProps = {
    DynamicParams: false,
    reportName: null,
    reportParams: null,
    id: 'generalReportFrame',
    name: 'generalReportFrame',
    title: 'Report',
    hiddenParameters: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      reportHTML: { __html: '<div>Loading...</div>' },
      loading: true,
      page: 1,
      reportParams: null,
    };
  }

  componentDidMount() {
    this.populateData();
  }

  populateData(format = 'HTML4.0', refresh = false) {
    if (this.state.reportParams === null) return;
    this.setState({ loading: true });
    if (this.props.reportName) {
      ReportService.GetReportAsync(this.props.reportName, this.state.reportParams, this.state.page, format)
        .then((result) => this.onDataReceived(result, format))
        .catch((error) => this.onError(error));
    } else {
      this.setState({ reportHTML: { __html: '<div>Errorcode:RF31 (ReportName is not set)</div>' } });
    }
  }

  onError(error) {
    ErrorMessage.LogDevInfo(error, 'ReportFrame', ErrorMessage.EveryWhere);
    this.setState({
      reportHTML: { __html: '<div>Errorcode:RF36</div>' },
      loading: false,
    });
  }

  onDataReceived(result, format) {
    const reportHTML = result.error
      ? result.error.includes('Validation Error:')
        ? `<div>${result.error}</div>`
        : '<div>Errorcode: RF40</div>'
      : result.htmlResult;
    if (format === 'HTML4.0') {
      this.setState({
        reportHTML: { __html: reportHTML },
        loading: false,
      });
      return;
    }
    const byteCharacters = atob(result.fileBytes);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    saveAs(new Blob([byteArray], { type: result.contentType }), result.fileName);
    this.setState({ loading: false });
  }

  printReport() {
    const iframe = document.getElementById(this.props.id);
    iframe.focus();
    iframe.contentWindow.print();
  }

  clickOnViewReport(reportParams) {
    this.setState({ reportParams: { ...reportParams } }, () => this.populateData('HTML4.0', true));
  }

  reportFrameParameterBarErrorHandler(error) {
    ErrorMessage.LogDevInfo(error, 'ReportFrame', ErrorMessage.EveryWhere);
    this.setState({
      reportHTML: { __html: '<div>Errorcode:RF93</div>' },
      loading: false,
    });
  }

  render() {
    return (
      <div
        className='bravo-ds'
        style={{ display: 'flex', flexFlow: 'column', height: '100%', minHeight: 'calc(100vh - 80px)' }}
      >
        <ReportFrameParameterBar
          DynamicParams={this.props.DynamicParams}
          reportName={this.props.reportName}
          reportParams={this.props.reportParams}
          clickOnViewReport={this.clickOnViewReport.bind(this)}
          errorHandler={(error) => this.reportFrameParameterBarErrorHandler(error)}
          hiddenParameters={this.props.hiddenParameters}
        />
        {this.state.loading ? (
          <BravoLoader variant='inline' className='rf-loading' />
        ) : (
          <>
            <ReportFrameOperationBar
              downloadReport={(format) => this.populateData(format)}
              printReport={() => this.printReport()}
              refreshReport={() => this.populateData('HTML4.0', true)}
            />
            <iframe
              style={{ flex: '1 1 auto', minHeight: '80vh' }}
              id={this.props.id}
              name={this.props.name}
              title={this.props.title}
              srcDoc={this.state.reportHTML.__html}
            />
          </>
        )}
      </div>
    );
  }
}
